<template>
  <section class="flex h-full flex-col">
    <div class="flex flex-col items-center gap-24 pb-72">
      <RevIllustration
        alt=""
        data-test="intro-illustration"
        :height="240"
        src="/img/buyback/swapIntroViewPlp.svg"
        :width="327"
      />
      <div>
        <h2 class="heading-1 mb-4">{{ i18n(translations.title) }}</h2>
        <h3 class="body-2">{{ i18n(translations.subTitle) }}</h3>
      </div>
      <RevList :has-external-borders="false">
        <RevListItemStatic>
          <template #prefix> <IconBadge /> </template>
          <template #label> {{ i18n(translations.listBadgeTitle) }} </template>
          <template #description>
            {{ i18n(translations.listBadgeDescription) }}
          </template>
        </RevListItemStatic>
        <RevListItemStatic>
          <template #prefix> <IconPackage /> </template>
          <template #label>
            {{ i18n(translations.listPackageTitle) }}
          </template>
          <template #description>
            {{ i18n(translations.listPackageDescription) }}
          </template>
        </RevListItemStatic>
        <RevListItemStatic>
          <template #prefix> <IconMoney /> </template>
          <template #label> {{ i18n(translations.listMoneyTitle) }}</template>
          <template #description>
            {{ i18n(translations.listMoneyDescription) }}
          </template>
        </RevListItemStatic>
      </RevList>
    </div>
  </section>

  <div class="bg-surface-default-mid absolute bottom-0 left-0 right-0 m-24">
    <RevButton
      class="mt-16"
      data-qa="user-yes"
      data-test="user-yes"
      full-width="always"
      variant="primary"
      @click="startSwap"
    >
      {{ i18n(translations.getOffer) }}
    </RevButton>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevList } from '@ds/components/List'
import { RevListItemStatic } from '@ds/components/ListItemStatic'
import { IconBadge } from '@ds/icons/IconBadge'
import { IconMoney } from '@ds/icons/IconMoney'
import { IconPackage } from '@ds/icons/IconPackage'

import translations from './Intro.translations'

const i18n = useI18n()

const emit = defineEmits(['close', 'next-step'])

function startSwap() {
  emit('next-step')
}
</script>
